export default function categoryMenu() {
  if (!$('.categories-menu').length)
    return;

  initCategoryMenuClickhandlers();
  categoryMenuItemClickHandler();
  hideUncategorizedFromMenu();
}

function initCategoryMenuClickhandlers() {
  $('.open-cat-btn').on('click', function(e) {
    e.preventDefault();
    categoryMenuItemClickHandler(this);
  });
}

function categoryMenuItemClickHandler(menuItem) {
  $('.category-menu-item', $(menuItem).parent()).removeClass('active');
  $(menuItem).parent().toggleClass('active');
}

function hideUncategorizedFromMenu() {
  $('.category-link:contains("Okategoriserad"), .category-link:contains("Uncategorized")').parent().remove()
}
